import api from "@/lib/api";

// Fire-and-forget outbound click tracking. Records CLICKS only — never implies follows/joins.
export const trackClick = (action) => {
  try {
    api.post("/track/click", { action, source_page: window.location.pathname }).catch(() => {});
  } catch {
    /* analytics must never break the experience */
  }
};

export const waDigits = (phone) => (phone || "").replace(/\D/g, "");
